import { useGasFee } from '@ui/hooks/useGasFee';
import { useEstimateRemoveMarginGasLimit } from '@ui/services/contract/hooks/TradingPortalFacet/useEstimateRemoveMarginGasLimit';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { isNil } from 'lodash-es';

import { useRemoveMarginOracleData } from './useRemoveMarginOracleData';
import { useWithdrawCollateralInput } from './useWithdrawCollateralInput';
import { useWithdrawCollateralValidation } from './useWithdrawCollateralValidation';

export const useWithdrawCollateralGasFee = (position: Position) => {
  const amount = useWithdrawCollateralInput((v) => v.input.value.token);
  const validation = useWithdrawCollateralValidation({ position });
  const oracleData = useRemoveMarginOracleData(position);

  const { data: gasLimit } = useEstimateRemoveMarginGasLimit({
    amount: amount,
    payToken: position.collateralToken,
    positionHash: position.id,
    oracleData,
    opts: {
      // Skip the estimate for invalid amounts: it would revert on-chain and
      // only produce error noise + a stuck "--" gas display.
      enabled: !isNil(amount) && !validation.error,
    },
  });

  return useGasFee(gasLimit);
};
